export default "__VITE_ASSET__RiQo4eVn__"